import { render, staticRenderFns } from "./ShipmentAchievmentDifferenceSelect.vue?vue&type=template&id=197fefa2&"
import script from "./ShipmentAchievmentDifferenceSelect.vue?vue&type=script&lang=js&"
export * from "./ShipmentAchievmentDifferenceSelect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports